// Premium Animations - Smooth, Sophisticated, Sales-Focused
if (typeof gsap !== 'undefined') {
  gsap.registerPlugin(ScrollTrigger);

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!prefersReducedMotion) {
    // ===== HERO PARALLAX =====
    gsap.utils.toArray('[data-parallax-hero]').forEach((hero) => {
      gsap.to(hero, {
        backgroundPosition: '50% 100px',
        ease: 'none',
        scrollTrigger: {
          trigger: hero,
          start: 'top top',
          end: 'bottom top',
          scrub: 1.2,
          markers: false,
        },
      });
    });

    // ===== SCROLL REVEALS - Staggered & Smooth =====
    gsap.utils.toArray('[data-story-block]').forEach((block, index) => {
      gsap.from(block, {
        opacity: 0,
        y: 60,
        duration: 0.9,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: block,
          start: 'top 85%',
          toggleActions: 'play none none none',
          markers: false,
        },
        delay: index * 0.1,
      });
    });

    // ===== PRODUCT CARDS - Smooth Hover with 3D Feel =====
    gsap.utils.toArray('.product-showcase__card').forEach((card) => {
      const image = card.querySelector('.product-showcase__image');

      card.addEventListener('mouseenter', () => {
        gsap.to(card, {
          y: -12,
          duration: 0.5,
          ease: 'power2.out',
          overwrite: 'auto',
        });
        if (image) {
          gsap.to(image, {
            scale: 1.08,
            duration: 0.6,
            ease: 'power2.out',
          });
        }
      });

      card.addEventListener('mouseleave', () => {
        gsap.to(card, {
          y: 0,
          duration: 0.4,
          ease: 'power2.out',
          overwrite: 'auto',
        });
        if (image) {
          gsap.to(image, {
            scale: 1,
            duration: 0.4,
            ease: 'power2.out',
          });
        }
      });
    });

    // ===== SECTION FADE-INS =====
    gsap.utils.toArray('.social-proof__testimonial').forEach((card, index) => {
      gsap.from(card, {
        opacity: 0,
        y: 40,
        duration: 0.7,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: card,
          start: 'top 80%',
          toggleActions: 'play none none none',
        },
        delay: index * 0.08,
      });
    });

    // ===== CTA BUTTON PULSE ON SCROLL INTO VIEW =====
    gsap.utils.toArray('.hero-premium__cta').forEach((cta) => {
      gsap.set(cta, { scale: 1 });

      cta.addEventListener('mouseenter', () => {
        gsap.to(cta, {
          scale: 1.05,
          duration: 0.3,
          ease: 'back.out',
        });
      });

      cta.addEventListener('mouseleave', () => {
        gsap.to(cta, {
          scale: 1,
          duration: 0.3,
          ease: 'back.out',
        });
      });
    });

    // ===== STAT COUNTERS - Count up on scroll =====
    gsap.utils.toArray('.social-proof__stat-number').forEach((stat) => {
      const finalNumber = parseInt(stat.textContent);
      let isAnimated = false;

      ScrollTrigger.create({
        trigger: stat,
        start: 'top 80%',
        onEnter: () => {
          if (!isAnimated) {
            gsap.to(
              { value: 0 },
              {
                value: finalNumber,
                duration: 2,
                ease: 'power2.out',
                onUpdate: function () {
                  stat.textContent = Math.floor(this.targets()[0].value) + '+';
                },
              }
            );
            isAnimated = true;
          }
        },
      });
    });
  }

  // ===== PERFORMANCE: Disable heavy animations on mobile =====
  if (window.innerWidth < 768) {
    gsap.globalTimeline.clear();
    // Simpler animations for mobile
    gsap.utils.toArray('[data-story-block]').forEach((block) => {
      gsap.from(block, {
        opacity: 0,
        duration: 0.6,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: block,
          start: 'top 85%',
          toggleActions: 'play none none none',
        },
      });
    });
  }
}
